import axios from 'axios'
import { GC_API } from '../config/global'

const apiClient = axios.create({
    baseURL: GC_API.baseUrl + 'files/',
    headers: {
        ...GC_API.baseHeaders
    }
})

export default {
    getFiles() {
        return apiClient.get()
    },
    getFileById(id) {
        return apiClient.get(id)
    }
}


// WEBPACK FOOTER //
// ./src/services/fileService.js